import React from 'react';
import Typography from '@material-ui/core/Typography';
import {
  createStyles, Theme, WithStyles, withStyles,
} from '@material-ui/core/styles';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import 'react-table/react-table.css';
import Paper from '@material-ui/core/Paper';

import ImportanceEndStatesTable from './ImportanceEndStatesTable';
import { QRLabelMapJSON } from '../../Quantification/QuantificationResultJSON';
import CutsetItemChip from '../Chips/CutsetItemChip';
import TreeContextProvider from '../../SingleHCLModelView/TreeContext';

const styles = (theme: Theme) => createStyles({
  darker: {
    background: theme.palette.type === 'dark' ? 'rgba(60,60,60,0.2)' : 'rgba(120,120,120,0.08)',
  },
  root: {
    height: '100%',
    margin: '0',
    overflow: 'auto',
    padding: '0',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
  },
  probContainer: {
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    height: '100%',
    marginTop: '0',
  },
  labelProb: {
    fontSize: '2rem',
    userSelect: 'all',
  },
  rootProb: {
    padding: '24px 0px',
  },
  cutsetChip: {
    margin: `0px ${theme.spacing(0.5)}px`,
    flexDirection: 'row',
  },
  cutsetRowItem: {
    flexDirection: 'row',
  },
  cutsetRow: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  rowItem: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  subcomponent: {
    padding: 'unset',
    background: 'rgba(0, 0, 0, 0.03)',
  },
});

interface QuantificationResultResponse {
  configuration?: {
    constructor: {
      tree_id: number;
    };
    engine: {
      BBNSolver: number;
      BDDConstructor: number;
      OrderingRule: number;
    };
    quantify: {
      targets: string;
    };
  };
  creator?: number;
  date_created?: string;
  id?: number;
  model?: number;
  model_title?: string;
  result_data?: {[index: string]: any};
  importance?: {[index: string]: any};
}

interface Props extends WithStyles<typeof styles>, WrappedComponentProps {
  noSlide: boolean;
  title: string;
  loading: boolean;
  loadingText: string;
  noDataText: string;
  data: QuantificationResultResponse;
  treeType: string;
  sequenceName: string;
  importanceData: string;
  map: QRLabelMapJSON;
}

interface State {
  importanceIdx: number;
  keyIdx: number;
  contentIdx: number;
}

class ImportanceMeasureContent extends React.Component <Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const {
      classes, data, map, ...others
    } = this.props;

    const treeID = data.configuration.constructor.tree_id;

    const endstatesToArray = (data: any) => {
      return Object.entries(data).map(entry => ({
        name: entry[0],
        measures: entry[1],
      }));
    };

    const endStatesData = data.result_data.importance.sequences;
    const endStateColumns = () => {
      return ([
        {
          id: 'name',
          Header: <Typography variant="h6" align="center">Name</Typography>,
          accessor: (d: any) => <CutsetItemChip variant="default" map={map} name={d.name} />,
        },
      ]);
    };
    return (
      <Paper className={classes.root} {...others} square elevation={0}>
        <div className={classes.darker}>
          {/*
          // @ts-ignore */}
          <TreeContextProvider treeId={treeID}>
            <ImportanceEndStatesTable
              map={map}
              // @ts-ignore
              data={endstatesToArray(endStatesData)}
              // @ts-ignore
              cols={endStateColumns()}
            />
          </TreeContextProvider>
        </div>
      </Paper>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(injectIntl(ImportanceMeasureContent));
